
<app-pre-loader *ngIf="IsLoadingResults"></app-pre-loader>

<div class="navbar navbar-default navpage-header" Id="div1">
    <div class="container-fluid">
        <div class="navbar-header" nav-banner-logo="">
            <a class="navbar-brand">
                <img id="mainBannerImage16" id="img1" src="assets/img/EY_Logo.png" aria-hidden="true">
                <span class="sr-only">In TaxGTC</span></a>
            <span class="banner-text h4" id="SpanId1">In TaxGTC</span>
        </div>
    </div>
  </div>
  
  <div class="content-wrapper">
    <div class="container">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 logout-body">
                    <div class="row" id="divid3">
                        <div class="col-md-1">
                            <i class="pi pi-exclamation-triangle" id="Logout"></i>
                        </div>
                        <div class="col-md-10 text-left" Id="divid2">
                            <h3>You have successfully logged out.</h3>
                            <span id="SpanId2"><a id="Anchor1" (click)="Login()">Please Click Here to Re-login</a>
                            </span>
                            
                        </div>
                     
                    </div>
                    <!-- Test Login disabled
                    <div style="margin: 10px; padding: 10px;">
                        <div class="row">
                            <div class="mb-3 col-md-5">
                                <label>Test Login </label>
                                <input class="form-control col-md-8" id="message"
                                 type="text"
                                 name="message">
                          <button class="btn-primary1" (click)="LoginValue()" 
                          type="button"
                          
                            mat-stroked-button>
                            Login With Email
                          </button>
                          
                            </div>
                        </div>
                        <div class="row" style="margin: 5px; padding: 10px;">
                            <label style="color: red; font-size: 15px;">Note :This is the test login for testers ,
                                 Test the application with different mail id's with different role's</label>
    
                        </div>
                    </div>
                    -->
                    
                </div>
            </div>
  
        </div>
    </div>
  </div>
  